import { markRaw, reactive, type Component } from "vue";
import MSpinnerBall from "../components/medicus/MSpinnerBall";

// ENG-20861: in-house replacement for the quasar `Loading` plugin. A singleton controller
// backing a single app-level <LoadingOverlay/> (see components/shared/LoadingOverlay.vue).
// Behaviour mirrors quasar's Loading: show() arms a delay timer before the overlay appears;
// hide() cancels a pending timer and hides. Only the options the app actually uses are kept
// (spinner, delay, customClass/boxClass) — no message/colour/group support.

export interface LoadingOptions {
  spinner?: Component;
  delay?: number;
  // quasar exposed both; here they both add a class to the single overlay element
  customClass?: string;
  boxClass?: string;
}

export const loadingState = reactive({
  visible: false,
  spinner: markRaw(MSpinnerBall) as Component,
  overlayClass: "",
});

let timer: ReturnType<typeof setTimeout> | null = null;

function clearTimer() {
  if (timer !== null) {
    clearTimeout(timer);
    timer = null;
  }
}

export const loading = {
  show(opts: LoadingOptions = {}) {
    loadingState.spinner = markRaw(opts.spinner ?? MSpinnerBall);
    loadingState.overlayClass = (opts.customClass ?? opts.boxClass ?? "").trim();

    // already visible → just update props (quasar force-updates the mounted overlay)
    if (loadingState.visible) return;

    clearTimer();
    timer = setTimeout(() => {
      timer = null;
      loadingState.visible = true;
    }, opts.delay ?? 0);
  },

  hide() {
    clearTimer();
    loadingState.visible = false;
  },
};
